export const notificationRouteMap = {
  customer_created: id => `/sales/customers/details/${id}`,

  transfer_created: id => `/inventory/stock/transfers/details/${id}`,
  transfer_approved: id => `/inventory/stock/transfers/details/${id}`,   // ← add
  transfer_rejected: id => `/inventory/stock/transfers/details/${id}`,   // ← add
  stock_request_created: id => `/inventory/stock/transfers/details/${id}`,
  stock_request_approved: id => `/inventory/stock/transfers/details/${id}`, // ← add
  stock_request_rejected: id => `/inventory/stock/transfers/details/${id}`,

  maintenance_created: id => `/vehicle/maintenance/details/${id}`,
  maintenance_approved: id => `/vehicle/maintenance/details/${id}`,
  maintenance_rejected: id => `/vehicle/maintenance/details/${id}`,

  expense_created: id => `/expenses/details/${id}`,
  expense_approved: id => `/expenses/details/${id}`,
  expense_rejected: id => `/expenses/details/${id}`,

  penalty_created: id => `/vehicle/penalties/details/${id}`,

  incentive_achieved: id => `/commission-plan/incentives/details/${id}`,

  low_stock: id => `/inventory/variants/details/${id}`,
};


export const getNotificationRedirectUrl = (notif) => {
  if (!notif?.type || !notif?.target_id) return null;

  const resolver = notificationRouteMap[notif.type];
  return resolver ? resolver(notif.target_id) : null;
};
